import { randomNumberFromInterval } from '../../../utils/math-utils'

type Dimensions = { containerHeight: number, containerWidth: number }

type BubbleGenerationArgs = {
  column: number
  row: number
  rowHeight: number
}

const BUBBLE_BASE_SIZE = 50
const MAX_BUBBLE_SIZE = BUBBLE_BASE_SIZE * 1.5
const MIN_BUBBLE_SIZE = BUBBLE_BASE_SIZE * 0.5
const COLUMN_WIDTH = MAX_BUBBLE_SIZE * 1.5
const OFFSET = 0

function getInitPropertiesForBubble({ column, row, rowHeight }: BubbleGenerationArgs) {
  const radius = randomNumberFromInterval(MIN_BUBBLE_SIZE, MAX_BUBBLE_SIZE, 2)
  const minX = column * COLUMN_WIDTH + radius
  const maxX = minX + COLUMN_WIDTH - radius
  const minY = row * rowHeight + radius
  const maxY = minY + rowHeight - radius

const x = randomNumberFromInterval(minX, maxX)
  const y = randomNumberFromInterval(minY, maxY)

  return { x, y, radius }
}

type BubbleProps = {
  x: number, y: number, radius: number
}

export function createBubbleGenerator(dimensions: Dimensions): () => BubbleProps {
  const { containerWidth: width, containerHeight: height } = dimensions
  const numberOfRows = Math.floor(height / (MAX_BUBBLE_SIZE * 1.5))
  const rowHeight = height / numberOfRows
  let index = 0
  let column = 0
  let row = 0
  let side: 'left' | 'right' = 'right'
  let direction: 'up' | 'down' = 'up'

  return () => {
    const { x, y, radius } = getInitPropertiesForBubble({ column, row, rowHeight })

    // Push the bubble over from the side so it starts out of view. Every other bubble starts from right side, 
    // and every other from left side.
    const distanceFromEdge = x - width
    const xWithOffset = side === 'right' ? width + distanceFromEdge :  -1 * (distanceFromEdge)

    side = side === 'right' ? 'left' : 'right'
    const towardsTop = direction === 'up'

    if ((towardsTop && row === numberOfRows - 1) || (!towardsTop && row === 0)) {
      // We are at the top or at the bottom --> Switch direction
      direction = direction === 'up' ? 'down' : 'up'
    } else {
      // Next row is either one up or one down based on the current direction.
      row = towardsTop ? row + 1 : row - 1
    }
  
    // All cells for the current column have been filled --> start filling the next column.
    if (((index + 1) % numberOfRows * 2) === 0) {
      column++
    }

    index++
    return { x: xWithOffset, y, radius }
  }
}